/* ============================================================
   ctr-video-testimonials — poster click-to-play (pauses the
   other videos) and a mobile-only Swiper slider with external
   prev/next controls.
   ============================================================ */

(function () {
  'use strict';

  function initCards(root) {
    var cards = root.querySelectorAll('.ctr-video-testimonials__card');

    cards.forEach(function (card) {
      var poster = card.querySelector('.ctr-video-testimonials__poster');
      var video = card.querySelector('.ctr-video-testimonials__video');
      if (!poster || !video) return;

      poster.addEventListener('click', function () {
        cards.forEach(function (other) {
          if (other === card) return;
          var otherVideo = other.querySelector('.ctr-video-testimonials__video');
          if (otherVideo) otherVideo.pause();
        });
        video.play();
      });

      video.addEventListener('play', function () {
        card.classList.add('is-playing');
      });
      video.addEventListener('pause', function () {
        card.classList.remove('is-playing');
      });
      video.addEventListener('ended', function () {
        card.classList.remove('is-playing');
      });
    });
  }

  function initSlider(root) {
    var sliderEl = root.querySelector('.ctr-video-testimonials__slider');
    if (!sliderEl || !window.Swiper) return;

    var slider = null;
    var mobileQuery = window.matchMedia('(max-width: 767px)');
    var prevBtn = root.querySelector('[data-ctr-prev]');
    var nextBtn = root.querySelector('[data-ctr-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (slider) slider.slidePrev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (slider) slider.slideNext();
      });
    }

    function setup() {
      if (mobileQuery.matches) {
        if (!slider) {
          slider = new Swiper(sliderEl, {
            slidesPerView: 1.05,
            spaceBetween: 24
          });
        }
      } else if (slider) {
        slider.destroy(true, true);
        slider = null;
      }
    }

    setup();
    mobileQuery.addEventListener('change', setup);
  }

  function initSection(root) {
    if (root.dataset.ctrVtInit) return;
    root.dataset.ctrVtInit = 'true';
    initCards(root);
    initSlider(root);
  }

  function initAllSections() {
    document.querySelectorAll('[data-ctr-video-testimonials]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', initAllSections);
})();
